import { callAPI } from "@/api/httpservice";
import type { Athlete, ReportError, ValidorResponse } from "@/types/file.types";

export function getValidorFiles() {
  return callAPI<ValidorResponse>("GET", `/quality-control`, null);
}

export function getSpecificValidate(envelopeId: string, polling?: boolean) {
  return callAPI<ValidorResponse>(
    "GET",
    `/quality-control/envelopes/${envelopeId}${polling ? "?polling" : ""}`,
    null
  );
}

export function validateAthlete(envelopeId: string) {
  return callAPI<void>(
    "PATCH",
    `/quality-control/validate/envelopes/${envelopeId}`,
    null
  );
}

export function searchAthlete(
  status: string,
  page: number,
  limit: number,
  search: string
) {
  return callAPI<{ items: Athlete[]; count: number }>(
    "GET",
    `/athletes?page=${page}${
      status && "&status=" + status
    }&limit=${limit}&search=${search}`,
    null
  );
}

export function sendAthletReport(report: ReportError[]) {
  return callAPI<void>("POST", `/files-errors`, report);
}

export function removeFile(fileId: string) {
  return callAPI<void>("PATCH", `/files/${fileId}/discarded`, null);
}

export function reportUnknownAthlet(envId: string) {
  return callAPI<void>("PATCH", `/envelopes/${envId}/athletes/unlink`, null);
}

export function reportBadAthlet(
  badEnvId: string,
  badAthleteId: string,
  disciplineCode1: string,
  goodAthleteId: string,
  disciplineCode2: string
) {
  return callAPI<ValidorResponse>(
    "PUT",
    `/envelopes/${badEnvId}/athletes/${badAthleteId}/${disciplineCode1}/switch/${goodAthleteId}/${disciplineCode2}?validation`,
    null
  );
}

export function setDescription(fileId: string, description: string) {
  return callAPI<void>(
    "PATCH",
    `/files/${fileId}/${description}/set-description`,
    null
  );
}

export function leaveValidation(envId: string, manual?: boolean) {
  return callAPI<void>(
    "POST",
    `/envelopes/${envId}/leave-validation${manual ? "?manual" : ""}`,
    null
  );
}

export function unprocessable(envId: string) {
  return callAPI<void>("PATCH", `/envelopes/${envId}/unprocessable`, null);
}
